import { render, staticRenderFns } from "./program-at-a-glance.vue?vue&type=template&id=4c147bbf&scoped=true&"
import script from "./program-at-a-glance.vue?vue&type=script&lang=js&"
export * from "./program-at-a-glance.vue?vue&type=script&lang=js&"
import style0 from "./program-at-a-glance.vue?vue&type=style&index=0&id=4c147bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c147bbf",
  null
  
)

export default component.exports